import axios from 'axios'

const baseURL = import.meta.env.VITE_BETTING_ACCEPTANCE_BASE_URL

const apiInstance = axios.create({
  baseURL,
  timeout: 5000
})

export default apiInstance
